export function getEntityId(entity) {
    let entityId = entity.class && entity.class.length ? entity.class[0] : "";

    return entityId;
}
